<script>
/* eslint-disable */
export default {
  props: {
    courtesy: {type: Object},
    editable: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.courtesy.status != 'NOT_AVAILABLE' && this.courtesy.status != 'ACCEPTED') {
      this.courtesy.status = 'NOT_AVAILABLE'
    }
    this.courtesy.requested = this.courtesy.requested || false
  },
}
</script>

<template>
  <v-row no-gutters>
    <v-col class="col-5 m-t-15 col-md-5 col-sm-12 bold-900">
      {{ $t('appointments.detail.courtesy-bike').toUpperCase() }}
    </v-col>
    <v-col class="col-7 col-md-7 col-sm-12">
      <v-row>
        <v-col class="col-6 col-md-6 col-sm-12">
          <v-row no-gutters>
            <div class="col-12 subtitle">{{ $t('appointments.detail.requested-by-client').toUpperCase() }}</div>
            <div class="col-12">
              <select
                id="courtesy-requested-select"
                v-model="courtesy.requested"
                class="form-select"
                :disabled="!editable">
                <option value="true">{{ $t('appointments.detail.yes') }}</option>
                <option value="false">{{ $t('appointments.detail.no') }}</option>
              </select>
            </div>
          </v-row>
        </v-col>
        <v-col class="col-6 col-md-6 col-sm-12">
          <v-row no-gutters>
            <v-col class="col-12 subtitle"> {{ $t('appointments.detail.availability').toUpperCase() }} </v-col>
            <v-col class="col-12">
              <select
                id="courtesy-availability"
                v-model="courtesy.status"
                class="form-select"
                :disabled="!courtesy.requested || courtesy.requested === 'false'">
                <option value="NOT_AVAILABLE">{{ $t('appointments.detail.not-available').toUpperCase() }}</option>
                <option value="ACCEPTED">{{ $t('appointments.detail.available').toUpperCase() }}</option>
              </select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<style scoped>
.subtitle {
  font-family: 'ProximaNovaExCnLight', 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-size: 14px;
  color: #888;
}
</style>
